import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Module from "./module/Module";
import RoutedModulePage from "./RoutedModulePage";
import { getModuleBySlug, getModuleSections } from "../../api/subjects";

const normalize = (value) => String(value ?? "").trim();

const getSectionSlug = (section) => normalize(section?.sectionSlug || section?.slug);

const mergeSections = (moduleSections, catalogSections) => {
    const map = new Map();

    [...(Array.isArray(moduleSections) ? moduleSections : []), ...(Array.isArray(catalogSections) ? catalogSections : [])]
        .filter((section) => section && getSectionSlug(section))
        .forEach((section) => {
            map.set(getSectionSlug(section), section);
        });

    return Array.from(map.values()).sort((a, b) => Number(a?.order ?? 0) - Number(b?.order ?? 0));
};

const DbModuleRuntimePage = ({ userName, userRoles }) => {
    const { id, subject, author, moduleSlug } = useParams();
    const [moduleData, setModuleData] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        let mounted = true;

        async function load() {
            if (!id || !subject || !author || !moduleSlug) return;
            setLoading(true);
            try {
                const [moduleResult, sectionsResult] = await Promise.allSettled([
                    getModuleBySlug(id, subject, author, moduleSlug),
                    getModuleSections(id, subject, author),
                ]);
                if (!mounted) return;

                if (moduleResult.status !== "fulfilled") {
                    setModuleData(null);
                    return;
                }

                const data = moduleResult.value;
                const catalogSections =
                    sectionsResult.status === "fulfilled" && Array.isArray(sectionsResult.value)
                        ? sectionsResult.value
                        : [];

                setModuleData({
                    title: data?.title || "",
                    sections: mergeSections(data?.sections, catalogSections),
                    questions: Array.isArray(data?.questions) ? data.questions : [],
                    pdfPath: data?.pdfPath || null,
                    pdfFileName: data?.pdfFileName || null,
                });
            } catch (e) {
                if (mounted) setModuleData(null);
            } finally {
                if (mounted) setLoading(false);
            }
        }

        load();
        return () => {
            mounted = false;
        };
    }, [id, subject, author, moduleSlug]);

    if (loading) return null;

    if (!moduleData) {
        return (
            <RoutedModulePage
                component={() => <div className="placeholder-content"><p>Модуль не знайдено або він без контенту</p></div>}
                module={{ title: "", questions: [] }}
                userName={userName}
                userRoles={userRoles}
            />
        );
    }

    return (
        <RoutedModulePage
            component={Module}
            module={moduleData}
            userName={userName}
            userRoles={userRoles}
        />
    );
};

export default DbModuleRuntimePage;
